<template>
  <section>
    <b-tabs
      vertical
      content-class="col-12 col-md-9 mt-1 mt-md-0"
      pills
      nav-wrapper-class="col-md-3 col-12"
      nav-class="nav-left"
      class="pt-1"
      v-model="active_tab"
    >

      <!-- general tab -->
      <b-tab :active="$route.params.section === 'general'"
        @click="$router.push({ name: 'pages-account-setting', params: { section: 'general' } }).catch(() => {})">

        <!-- title -->
        <template #title>
          <feather-icon
            icon="UserIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{$t('dashboard.profile')}}</span>
        </template>

        <account-setting-general
          v-if="active_tab === 0"
          :profile_dad="profile"
          :account_company="account_company"
          :loaded_profile="loaded"
          @update_profile="updateProfile"
        />
      </b-tab>
      <!--/ general tab -->

      <b-tab :active="$route.params.section === 'preferences'" 
        @click="$router.push({ name: 'pages-account-setting', params: { section: 'preferences' } }).catch(() => {})">

        <!-- title -->
        <template #title>
          <b-icon
            icon="gear"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{$t('preference')}}</span>
        </template>

        <account-setting-password 
          v-if="$route.params.section === 'preferences'"
          :profile_dad="profile"
          :loaded_profile="loaded"
          @update_profile="updateProfile"
        />

      </b-tab>

      <!--/ change password tab -->
      <!-- social links -->
      <b-tab :active="$route.params.section === 'social'"
        @click="$router.push({ name: 'pages-account-setting', params: { section: 'social' } }).catch(() => {})">

        <!-- title -->
        <template #title>
          <feather-icon
            icon="LinkIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{$t('social')}}</span>
        </template>

        <account-setting-social v-if="$route.params.section === 'social'"/>
      </b-tab>

       <!-- data payment -->
      <b-tab v-if="rol === 'creator'" :active="$route.params.section === 'payment-data'"
        @click="$router.push({ name: 'pages-account-setting', params: { section: 'payment-data' } }).catch(() => {})">
        <template #title>
          <feather-icon
            icon="DollarSignIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{$t('campaigns.has_payment_data')}}</span>
        </template>
        <account-setting-payment-data 
          :profile="profile" 
          :loaded="loaded" 
          @update_payment_data="updatePaymentData"
          v-if="$route.params.section === 'payment-data'"
        />
      </b-tab>


      <b-tab :active="$route.params.section === 'notification'"
        @click="$router.push({ name: 'pages-account-setting', params: { section: 'notification' } }).catch(() => {})">

        <!-- title -->
        <template #title>
          <b-icon
            icon="bell"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{$t('notification')}}</span>
        </template>
        <account-setting-notification-two v-if="$route.params.section === 'notification'"/>

      </b-tab>

      <b-tab 
        v-if="is_whitelabel_and_admin"
        :active="$route.params.section === 'aspect-whitelabel'"
        @click="$router.push({ name: 'pages-account-setting', params: { section: 'aspect-whitelabel' } }).catch(() => {})"
      >

        <!-- title -->
        <template #title>
          <div class="d-flex align-items-center">
            <b-icon
              icon="layout-text-sidebar-reverse"
              size="18"
              class="mr-50"
            />
            <span class="font-weight-bold">{{$t('aspectWhitelabel')}}</span>
            <b-badge variant="warning" class="ml-1 badge-beta">BETA</b-badge>
          </div>
        </template>
        <account-setting-aspect v-if="$route.params.section === 'aspect-whitelabel'"/>

      </b-tab>

      <b-tab 
        v-if="is_whitelabel_and_admin"
        :active="$route.params.section === 'members-whitelabel'"
        @click="$router.push({ name: 'pages-account-setting', params: { section: 'members-whitelabel' } }).catch(() => {})"
      >

        <template #title>
          <div class="d-flex align-items-center">
            <b-icon
              icon="list-ul"
              size="18"
              class="mr-50"
            />
            <span class="font-weight-bold">{{$t('membersWhitelabel')}}</span>
            <b-badge variant="secondary" class="ml-1 badge-beta">{{ $t('newFeature') }}</b-badge>
          </div>
        </template>
        <account-setting-members-white-label v-if="$route.params.section === 'members-whitelabel'"/>

      </b-tab>

      <b-tab v-if="rol === 'creator'" :active="$route.params.section === 'activity'"
        @click="$router.push({ name: 'pages-account-setting', params: { section: 'activity' } }).catch(() => {})">

        <!-- title -->
        <template #title>
          <b-icon
            icon="calendar2-check"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{$t('activity')}}</span>
        </template>
        <account-setting-activity v-if="$route.params.section === 'activity'"/>

      </b-tab>

      <b-tab v-if="rol !== 'realty'" :active="$route.params.section === 'membership'"
        @click="$router.push({ name: 'pages-account-setting', params: { section: 'membership' } }).catch(() => {})">
        <template #title>
          <b-icon
            icon="card-checklist"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{$t('membership')}}</span>
        </template>
        <account-setting-membership 
          v-if="$route.params.section === 'membership'"
          :profile="profile" 
          :loaded="loaded"
        />
      </b-tab>

      <b-tab 
        v-if="rol !== 'realty'" 
        :active="$route.params.section === 'billing'"
        @click="$router.push({ name: 'pages-account-setting', params: { section: 'billing' } }).catch(() => {})">
        <template #title>
          <svg
            class="img-18 mr-50"
            viewBox="0 -11 493.78 493"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="m378.351562 70.472656c.214844.015625.429688.03125.648438.03125.371094 0 .742188-.03125 1.105469-.082031 9.722656.199219 17.503906 8.128906 17.515625 17.851563 0 4.417968 3.582031 8 8 8 4.417968 0 8-3.582032 8-8-.019532-15.902344-11.089844-29.660157-26.621094-33.082032v-7.6875c0-4.417968-3.582031-8-8-8s-8 3.582032-8 8v8.050782c-16.421875 4.390624-27.046875 20.277343-24.832031 37.132812 2.214843 16.855469 16.582031 29.457031 33.582031 29.457031 9.871094 0 17.871094 8.003907 17.871094 17.875 0 9.867188-8 17.871094-17.871094 17.871094s-17.871094-8.003906-17.871094-17.871094c0-4.417969-3.582031-8-8-8-4.417968 0-8 3.582031-8 8 .019532 15.328125 10.316406 28.738281 25.121094 32.71875v8.765625c0 4.417969 3.582031 8 8 8s8-3.582031 8-8v-8.398437c16.894531-3.699219 28.289062-19.535157 26.425781-36.730469-1.859375-17.195312-16.378906-30.226562-33.675781-30.222656-9.597656.003906-17.484375-7.574219-17.863281-17.164063-.375-9.589843 6.894531-17.765625 16.464843-18.511719zm0 0"/>
            <path d="m380.207031.390625c-49.214843 0-91.214843 32.113281-106.949219 75.113281h-198.558593c-4.398438 0-7.96875 3.964844-8 8.359375l-1.890625 280.640625h-56.597656c-4.417969 0-8.210938 3.199219-8.210938 7.625v35.613282c.101562 33.527343 26.507812 61.070312 60 62.585937v.175781h247v-.234375c2 .074219 2.824219.234375 4.089844.234375h.171875c34.664062-.054687 62.738281-28.171875 62.738281-62.835937v-180.0625c2 .109375 4.117188.167969 6.1875.167969 62.628906 0 113.59375-51.0625 113.59375-113.695313 0-62.628906-50.941406-113.6875-113.574219-113.6875zm-317.164062 454.113281h-.050781c-25.878907-.035156-46.875-20.960937-46.992188-46.84375v-27.15625h232v27.042969c.011719 16.695313 6.679688 32.699219 18.523438 44.46875.839843.839844 1.882812 1.488281 2.761718 2.488281zm294.957031-46.84375c.003906 25.835938-20.914062 46.792969-46.746094 46.84375h-.152344c-25.9375-.046875-46.972656-21.015625-47.101562-46.949218v-35.425782c.066406-2.046875-.714844-4.027344-2.164062-5.472656-1.449219-1.445312-3.429688-2.222656-5.472657-2.152344h-175.554687l1.835937-273h186.171875c-1.417968 7.324219-2.152344 14.761719-2.191406 22.21875-.015625 15.769532 3.273438 31.363282 9.65625 45.78125h-75.5625c-4.421875 0-8 3.582032-8 8 0 4.417969 3.578125 8 8 8h84.242188c16.503906 25.953125 42.886718 44.046875 73.039062 50.101563zm22.207031-195.882812c-53.890625 0-97.582031-43.6875-97.578125-97.582032 0-53.894531 43.6875-97.582031 97.582032-97.582031 53.890624 0 97.578124 43.691407 97.578124 97.582031-.058593 53.867188-43.710937 97.523438-97.582031 97.582032zm0 0"/>
            <path d="m149.367188 212.746094c-14.121094 0-25.605469 11.121094-25.605469 24.792968 0 13.671876 11.484375 24.792969 25.605469 24.792969 14.121093 0 25.609374-11.121093 25.609374-24.792969 0-13.671874-11.488281-24.792968-25.609374-24.792968zm0 33.585937c-5.300782 0-9.605469-3.945312-9.605469-8.792969 0-4.851562 4.308593-8.792968 9.605469-8.792968 5.296874 0 9.609374 3.945312 9.609374 8.792968 0 4.847657-4.3125 8.792969-9.609374 8.792969zm0 0"/>
            <path d="m192.71875 237.503906c0 4.417969 3.578125 8 8 8h106.65625c4.417969 0 8-3.582031 8-8 0-4.417968-3.582031-8-8-8h-106.65625c-4.421875 0-8 3.582032-8 8zm0 0"/>
            <path d="m149.367188 143.203125c-14.121094 0-25.605469 11.125-25.605469 24.796875s11.484375 24.792969 25.605469 24.792969c14.121093 0 25.609374-11.121094 25.609374-24.792969s-11.488281-24.796875-25.609374-24.796875zm0 33.589844c-5.300782 0-9.605469-3.945313-9.605469-8.792969s4.308593-8.796875 9.605469-8.796875c5.296874 0 9.609374 3.945313 9.609374 8.796875 0 4.847656-4.3125 8.796875-9.609374 8.796875zm0 0"/>
            <path d="m149.367188 282.28125c-14.121094 0-25.605469 11.121094-25.605469 24.792969s11.484375 24.792969 25.605469 24.792969c14.121093 0 25.609374-11.121094 25.609374-24.792969s-11.488281-24.792969-25.609374-24.792969zm0 33.585938c-5.300782 0-9.605469-3.941407-9.605469-8.792969 0-4.847657 4.308593-8.792969 9.605469-8.792969 5.296874 0 9.609374 3.945312 9.609374 8.792969 0 4.847656-4.3125 8.792969-9.609374 8.792969zm0 0"/>
            <path d="m307.375 299.503906h-106.65625c-4.421875 0-8 3.582032-8 8 0 4.417969 3.578125 8 8 8h106.65625c4.417969 0 8-3.582031 8-8 0-4.417968-3.582031-8-8-8zm0 0"/>
          </svg>
          <span class="font-weight-bold">{{$t('memberships.billing')}}</span>
        </template>
        <account-setting-billing v-if="$route.params.section === 'billing'"/>
      </b-tab>


      <!-- Visited profiles -->
      <b-tab 
        v-if="showProfiles()" 
        :active="$route.params.section === 'visitedProfiles'"
        @click="$router.push({ name: 'pages-account-setting', params: { section: 'visitedProfiles' } }).catch(() => {})"
      >
       <template #title>
         <feather-icon
           icon="EyeIcon"
           size="18"
           class="mr-50"
         />
         <span class="font-weight-bold">{{$t('profileVisited')}}</span>
       </template>

       <account-setting-profiles-visited v-if="$route.params.section === 'visitedProfiles'"/>


     </b-tab>
     <b-tab 
         v-if="rol === 'creator' && permission_agency"
        :active="$route.params.section === 'proposal-agencies'"
        @click="$router.push({ name: 'pages-account-setting', params: { section: 'proposal-agencies' } }).catch(() => {})"
      >
        <template #title>
         <feather-icon
           icon="FolderIcon"
           size="18"
           class="mr-50"
         />
         <span class="font-weight-bold">{{ $t('proposalAgency')}}</span>
       </template>
       <account-setting-proposals-agency v-if="$route.params.section === 'proposal-agencies'"/>
      </b-tab>
      <!-- Brands -->
      <b-tab v-if="showProfiles()" :active="$route.params.section === 'brand'" @click="$router.push({ name: 'pages-account-setting', params: { section: 'brand' } }).catch(() => {})">
        <!-- title -->
        <template #title>
          <feather-icon
            icon="BriefcaseIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{$t('brand')}}</span>
        </template>

        <account-setting-brands v-if="$route.params.section === 'brand'"/>
      </b-tab>

      <!-- Export campaigns -->
      <b-tab v-if="showProfiles()" :active="$route.params.section === 'exports-campaigns'" @click="$router.push({ name: 'pages-account-setting', params: { section: 'exports-campaigns' } }).catch(() => {})">
        <!-- title -->
        <template #title>
          <feather-icon
            icon="ShareIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">Exportados</span>
        </template>

        <account-settings-export-reports-campaign v-if="$route.params.section === 'exports-campaigns'"/>
      </b-tab>
    </b-tabs>
  </section>
</template>

<script>
import { BTabs, BTab, BIcon, BBadge } from 'bootstrap-vue'
import service from '@/services/others'
import { getUserData, removeLocal, checkVerified } from '@/libs/utils/user';
const loadToastificationContent = () => import('@core/components/toastification/ToastificationContent.vue');

export default {
  components: {
    BIcon,
    BTabs,
    BTab,
    BBadge,
    AccountSettingGeneral: () => import('./AccountSettingGeneral.vue'),
    AccountSettingPassword: () => import('./AccountSettingPassword.vue'),
    AccountSettingSocial: () => import('./AccountSettingSocial.vue'),
    AccountSettingBrands: () => import('./AccountSettingBrands.vue'),
    AccountSettingProfilesVisited: () => import('./AccountSettingProfilesVisited.vue'),
    AccountSettingPaymentData: () => import('./AccountSettingPaymentData.vue'),
    AccountSettingMembership: () => import('./AccountSettingMembership.vue'),
    AccountSettingActivity: () => import('./AccountSettingActivity.vue'),
    AccountSettingNotificationTwo: () => import('./AccountSettingNotificationTwo.vue'),
    AccountSettingBilling: () => import('./AccountSettingBilling.vue'),
    AccountSettingAspect: () => import('./AccountSettingAspect.vue'),
    AccountSettingsExportReportsCampaign: () => import('@/views/pages/account-setting/AccountSettingsExportReportsCampaign.vue'),
    AccountSettingProposalsAgency: () => import('@/views/pages/account-setting/AccountSettingProposalsAgency.vue'),
    AccountSettingMembersWhiteLabel: () => import('@/views/pages/account-setting/AccountSettingMembersWhiteLabel.vue'),
  },
  data() {
    return {
      getUserData,
      checkVerified,
      removeLocal,
      active_tab: 0,
      permission_agency: false,
      agencies: {},
      profile: {
        main_group: {
          name: ''
        }
      },
      loaded: false,
      main_brand: {},
      email_paypal: '',
      viewEditBrand: false,
      account_company: {}
    }
  },
  computed: {
    rol() {
      return getUserData()?.groups[0]?.name;
    },
    is_whitelabel_and_admin() {
      const is_admin_whitelabel = getUserData()?.whitelabel_settings?.is_admin;
      return this.rol === 'whitelabel' && is_admin_whitelabel;
    }
  },
  beforeCreate () {
    service.getProfile()
      .then(response => {
        this.profile = response.user;
        this.agencies = this.profile?.user_agency || {}
        this.account_company = response.account_company
        this.loaded = false;
        if (this.rol !== 'creator' && this.rol !== 'realty') this.main_brand = (response.account_company && response.account_company.main_brand) ? response.account_company.main_brand : {}
        this.viewEditBrand = true
        this.loaded = true;
      })
      .catch(() => {
        this.loaded = true;
        loadToastificationContent().then((component) => {
          this.$toast({
            component: component.default,
            position: 'top-right',
            props: {
              title: this.$t('messageAccountSettingError'),
              icon: 'CoffeeIcon',
              variant: 'danger',
              text:this.$t('messageAccountSettingFailed')
            }
          })
        })
        removeLocal(this.$router)
      })
    this.$store.commit('appConfig/UPDATE_IS_VERIFIED', checkVerified());
  },
  destroyed() {
    const body = document.querySelector('div.app-content.content');
    body.removeAttribute('style');
  },
  created () {
    const user = getUserData();
    this.permission_agency = user?.user_permissions?.some(item => item.codename === 'user_agency') || false
  },
  methods: {
    updateProfile(new_profile) {
      this.profile = new_profile.user;
    },
    updatePaymentData(response, only_payment_data = false) {
      if (!only_payment_data) { 
        this.profile.paypal_info = response;
        this.profile.payment_data = response.payment_data;
      } else {
        this.profile.payment_data = response;
      }
    },
    showProfiles() {
      if (this.rol === 'creator' || this.rol === 'realty') return false
      return true
    },
  }
}
</script>
<style lang="scss" scoped>
.img-18 {
  width: 18px;
  height: 18px;
}
.badge-beta {
  font-size: 0.55rem;
  line-height: 1;
  padding: 0.25em 0.4em;
  letter-spacing: .5px;
}
</style>